import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const ProductGroupSchema = (localeCodes) =>
  Yup.object().shape({
    code: Yup.string()
      .label("ID")
      .required()
      .max(50),
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
    localizations: createLocalizationsSchema(localeCodes),
  });

export default ProductGroupSchema;
